import { render, staticRenderFns } from "./ContactReportRecipientButton.vue?vue&type=template&id=2e5b6945&"
import script from "./ContactReportRecipientButton.vue?vue&type=script&lang=js&"
export * from "./ContactReportRecipientButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports